import React from 'react';
import { PlansAndBilling } from './onboarding/v1/PlansAndBilling';

const PublicBillingAndPlans: React.FC = () => {
  return <PlansAndBilling />;
};

export default PublicBillingAndPlans;
